<template>
  <div class="sidebar-wrapper">
    <!-- Logo区域 - 点击折叠/展开 -->
    <div class="logo-container" @click="handleToggle">
      <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
      <span v-show="!isCollapse" class="logo-text">快影兔</span>
      <i v-show="!isCollapse" class="el-icon-arrow-left collapse-icon"></i>
    </div>

    <!-- 导航菜单 -->
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      :collapse="isCollapse"
      :collapse-transition="false"
      background-color="#1e1e1e"
      text-color="#b3b3b3"
      active-text-color="#8bff8b"
      router
    >
      <el-menu-item index="/home">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>

      <!-- 开始创作 - 弹窗，不选中 -->
      <div class="menu-item-wrapper" @click="handleCreateProject">
        <el-menu-item index="" :style="{ pointerEvents: 'none' }">
          <i class="el-icon-magic-stick"></i>
          <span slot="title">开始创作</span>
        </el-menu-item>
      </div>

      <!-- 我的项目：由点击处理跳转，避免未登录时 el-menu 先 push /projects 再被守卫重定向报错 -->
      <el-menu-item
        :class="{ 'is-active': $route.path === '/projects' }"
        index=""
        @click.native.prevent.stop="handleProjectsClick"
      >
        <i class="el-icon-folder-opened"></i>
        <span slot="title">我的项目</span>
      </el-menu-item>
      <!-- <el-menu-item index="/myAssets">
        <i class="el-icon-bank-card"></i>
        <span slot="title">我的资产</span>
      </el-menu-item> -->
    </el-menu>

    <!-- 底部菜单 -->
    <div class="bottom-menu">
      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        :collapse="isCollapse"
        :collapse-transition="false"
        background-color="#1e1e1e"
        text-color="#b3b3b3"
        active-text-color="#8bff8b"
      >
        <!-- 算力 - 弹窗，不选中 -->
        <div class="menu-item-wrapper" @click="handleCreditsClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <i class="el-icon-lightning"></i>
            <span slot="title">
              算力
              <el-tag size="mini" type="success" class="power-tag">{{
                userInfo.points || 0
              }}</el-tag>
            </span>
          </el-menu-item>
        </div>
        <!-- 消息 - 侧栏消息中心，不选中 -->
        <!-- <div class="menu-item-wrapper" @click="handleMessageClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <i class="el-icon-bell"></i>
            <span slot="title">消息</span>
          </el-menu-item>
        </div> -->
        <!-- 教程 - 弹窗，不选中 -->
        <div class="menu-item-wrapper" @click="handleTutorialClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <i class="el-icon-video-camera"></i>
            <span slot="title">教程</span>
          </el-menu-item>
        </div>

        <!-- AI短剧交流群 - 弹窗，不选中 -->
        <div class="menu-item-wrapper" @click="handleCommunityClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <i class="el-icon-chat-dot-round"></i>
            <span slot="title">AI短剧交流群</span>
          </el-menu-item>
        </div>

        <!-- 邀请有礼 - 路由跳转，可以有选中状态 -->
        <el-menu-item index="/invitation" @click="handleInvitationClick">
          <i class="el-icon-present"></i>
          <span slot="title">邀请有礼</span>
        </el-menu-item>

        <!-- 个人信息 - 弹窗，不选中 -->
        <div class="menu-item-wrapper" @click="handleProfileClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <i class="el-icon-user-solid"></i>
            <span slot="title">个人信息</span>
          </el-menu-item>
        </div>
      </el-menu>

      <!-- 登录按钮 -->
      <div
        class="login-btn"
        :class="{ 'is-collapse': isCollapse }"
        @click="handleLogin"
      >
        <i class="el-icon-user"></i>
        <span v-show="!isCollapse">{{ islogin ? "退出登录" : "登录" }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus, EVENTS } from "@/utils/eventBus";
import { userInfo, ainewAiSettinginfo } from "@/api";
export default {
  name: "Sidebar",
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      islogin: false,
      userInfo: {},
      AiSettinginfo: {},
    };
  },
  created() {
    this.getainewAiSettinginfo();
    this.checkLoginStatus();
    this.getuserInfo();
  },
  activated() {
    this.checkLoginStatus();
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
  },
  methods: {
    getainewAiSettinginfo() {
      ainewAiSettinginfo({}).then((res) => {
        if (res.code == 200) {
          this.AiSettinginfo = res.data;
        }
      });
    },
    getuserInfo() {
      if (!localStorage.getItem("userId")) return;
      userInfo({
        userId: localStorage.getItem("userId"),
      }).then((res) => {
        if (res.code == 200) {
          this.userInfo = res.data;
        }
      });
    },
    checkLoginStatus() {
      this.islogin = !!localStorage.getItem("userId");
    },

    handleToggle() {
      this.$emit("toggle");
    },

    handleLogin() {
      if (this.islogin) {
        localStorage.removeItem("userId");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        this.islogin = false;
      }
      this.$emit("login");
    },

    handleCreateProject() {
      if (!localStorage.getItem("userId")) return this.$emit("login");
      // 通过事件总线触发全局弹窗
      EventBus.$emit(EVENTS.SHOW_CREATE_PROJECT);
    },

    handleProjectsClick() {
      if (!localStorage.getItem("userId")) {
        this.$emit("login");
        return;
      }
      if (this.$route.path !== "/projects") {
        this.$router.push("/projects");
      }
    },

    handleCreditsClick() {
      if (!localStorage.getItem("userId")) return this.$emit("login");
      // 通过事件总线触发算力弹窗
      EventBus.$emit(EVENTS.SHOW_CREDITS_DIALOG);
    },

    handleTutorialClick() {
      let url = this.AiSettinginfo.tutorial;
      if (!url) return this.$message.warning("未配置教程地址");
      // 打开教程链接
      window.open(url, "_blank");
    },

    handleCommunityClick() {
      // 通过事件总线触发社群弹窗
      EventBus.$emit(EVENTS.SHOW_COMMUNITY_DIALOG);
    },

    handleInvitationClick() {
      if (!localStorage.getItem("userId")) return this.$emit("login");
      this.$router.push("/invitation");
    },

    handleProfileClick() {
      if (!localStorage.getItem("userId")) return this.$emit("login");
      EventBus.$emit(EVENTS.SHOW_PROFILE_DIALOG);
    },

    handleMessageClick() {
      if (!localStorage.getItem("userId")) return this.$emit("login");
      EventBus.$emit(EVENTS.SHOW_MESSAGE_CENTER);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.logo-container {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid #2d2d2d;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #2d2d2d;
  }

  .logo-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .logo-text {
    margin-left: 12px;
    font-size: 18px;
    font-weight: 600;
    color: #8bff8b;
    white-space: nowrap;
    flex: 1;
  }

  .collapse-icon {
    color: #888;
    font-size: 14px;
    transition: transform 0.3s ease;
  }
}

.sidebar-menu {
  border-right: none !important;

  ::v-deep .el-menu-item {
    height: 48px;
    line-height: 48px;
    font-size: 14px;

    &:hover {
      background-color: #2d2d2d !important;
    }

    &.is-active {
      background-color: #2d2d2d !important;
      color: #8bff8b !important;

      i {
        color: #8bff8b !important;
      }
    }

    i {
      font-size: 18px;
      margin-right: 10px;
      color: #b3b3b3;
    }
  }
}

// 包装器样式，用于处理弹窗菜单项的点击
.menu-item-wrapper {
  cursor: pointer;

  // 确保内部的el-menu-item不会触发选中状态
  ::v-deep .el-menu-item {
    cursor: pointer;

    &.is-active {
      background-color: transparent !important;
      color: #b3b3b3 !important;

      i {
        color: #b3b3b3 !important;
      }
    }
  }

  &:hover {
    ::v-deep .el-menu-item {
      background-color: #2d2d2d !important;
    }
  }
}

.bottom-menu {
  margin-top: auto;
  border-top: 1px solid #2d2d2d;
  padding-top: 8px;
}

.power-tag {
  margin-left: 8px;
  background-color: #8bff8b !important;
  border-color: #8bff8b !important;
  color: #1a1a1a !important;
}

.login-btn {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 20px;
  color: #8bff8b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;

  i {
    font-size: 18px;
    margin-right: 10px;
  }

  &.is-collapse {
    justify-content: center;
    padding: 0;

    i {
      margin-right: 0;
    }
  }

  &:hover {
    background-color: #2d2d2d;
  }
}
</style>
